<div class="space-y-6 search-page-container w-[100%]">
  <div class="search-page-header mb-0 w-[80vw]">
    <h2 class="text-2xl font-semibold">SEARCH FOR AN INDEX</h2>
  </div>
  <div class="search-page-content-wrapper bg-gray-100 border-gray-200 border-t flex justify-center w-[100%]">
    <div class="search-details-container w-[80vw]">
      <div>
        <h3 class="search-section-title text-lg font-semibold text-black border-l-4 pl-2  border-green-700">Results for
          "{{searchTerm}}"</h3>
        <div *ngIf="indexSearchInfo() as indexSearchItems">
          <ul *ngIf="indexSearchItems.length; else noResult">
            <li *ngFor="let items of indexSearchItems">
              <a [routerLink]="['/Strategy/Index']" [queryParams]="{ pid: items.ProductId, subid: items.SubProductId}">
                <i class="pi pi-angle-right text-green-700"></i> <span
                  class="hover:text-green-600 hover:border-b-2 border-green-600 font-open-sans">{{items.TechnicalName}}</span>
              </a>
            </li>
          </ul>
        </div>
        <ng-template #noResult>
          <p class="text-gray-600 italic">
            No Index found according to your search token.
          </p>
        </ng-template>
      </div>
    </div>
  </div>
</div>`